/**
 * a plugin for wx jssdk
 * https://mp.weixin.qq.com/wiki/11/74ad127cc054f6b80759c40f77ec03db.html
 */
import Vue from 'vue'
// import cache from '../../common/cache'
// import './jweixin-1.0.0'
// 使用 import 引入 windows 环境会报 agentConfig is not a function, 这里改成 index.html script标签引入
// import './jweixin-1.2.0'
// import './jwxwork-1.0.0'
import util from '../../common/util'
import cache from '../../common/cache'
// require('./jweixin-1.2.0') // cmd方式映入

export default class Wechat {
  static install () {}
  // 校验微信接口
  constructor(options) {
    this.wx = wx
    this.flag = window.DEBUG // DEBUG 状态下设为true
    this.res = null // 微信返回的校验成功的结果
    this.location = {
      latitude: 0,
      longitude: 0
    }

    // 需要检测的JS接口列表，所有JS接口列表见附录2
    this.jsApiList = []

    // merge 方法
    Object.assign(this, options)
    if (this.beforeCreate) {
      this.beforeCreate()
    }
    // this.checkWXConfig()

    // 构造函数执行完之后的hook
    if (this.created) {
      this.created()
    }
  }

  checkWXConfig () {
    // if (!cache.getSessionData('checkWxConfig')) {
    //   cache.setSessionData('checkWxConfig', 1)
    // } else {
    //   return
    // }
    this.promise = new Promise((resolve, reject) => {
      if (this.flag) {
        this.ready(resolve)
      } else {
        if (!this.getWechatConfigResource) {
          throw new Error('no defined getWechatConfigResource function')
        }
        this.getWechatConfigResource().then(async (res) => {
          if (res.code !== 0) {
            util.showToast(res.message)
            return
          }
          const { config, agent_config } = res.data
          // let data = res.config || res.data.config
          await this.wx.config({
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: config.timestamp, // 必填，生成签名的时间戳
            nonceStr: config.nonceStr, // 必填，生成签名的随机串
            signature: config.signature, // 必填，签名
            jsApiList: this.jsApiList
          })
          this.wx.ready(() => {
            try {
              this.wx.agentConfig({
                corpid: agent_config.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
                agentid: agent_config.agentid, // 必填，企业微信的应用id （e.g. 1000247）
                timestamp: agent_config.timestamp, // 必填，生成签名的时间戳
                nonceStr: agent_config.nonceStr, // 必填，生成签名的随机串
                signature: agent_config.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                jsApiList: this.jsApiList,
                success: () => {
                  checkJsApi(this, resolve, reject)
                },
                fail: (err) => {
                  console.log('fail error', err)
                  checkJsApi(this, resolve, reject)
                }
              })
            } catch (e) {
              console.log('catch error', e)
              // 缓存agentConfig 注入失败
              cache.setWechatAgentConfErr()
              checkJsApi(this, resolve, reject)
            }
          })

          // this.wx.ready(() => {
          //   // 判断当前客户端版本是否支持指定JS接口
          //   this.wx.checkJsApi({
          //     jsApiList: this.jsApiList,
          //     success: (res) => {
          //       this.flag = true
          //       this.res = res
          //       // resolve(this)
          //       this.ready(resolve)
          //     },
          //     error: (res) => {
          //       this.flag = false
          //       this.res = res
          //       reject(new Error('checkJsApi 失败'))
          //       throw new Error('checkJsApi 失败')
          //     }
          //   })
          // })
          this.wx.error((res) => {
            this.flag = false
            this.res = res
            reject(new Error('wxjssdk 注册失败'))
            throw new Error('wxjssdk 注册失败')
          })
        }, (res) => {
          this.res = res
          reject(new Error('wxjssdk 获取配置信息时报'))
          throw new Error('wxjssdk 获取配置信息时报')
        })
      }
    })

    return this.promise
  }

  setFlag (val) {
    this.flag = val
  }

  // sentry issues#30
  ready (resolve) {
    let onBridgeReady = () => {
      resolve(this)
    }
    if (typeof window.WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  }
}

function checkJsApi(WechatIns, resolve, reject) {
  WechatIns.wx.checkJsApi({
    jsApiList: WechatIns.jsApiList,
    success: (res) => {
      WechatIns.flag = true
      WechatIns.res = res
      // resolve(this)
      WechatIns.ready(resolve)
    },
    error: (res) => {
      WechatIns.flag = false
      WechatIns.res = res
      reject(new Error('checkJsApi 失败'))
      throw new Error('checkJsApi 失败')
    }
  })
}

/**
 * vue 组件安装方法
 * @return {[type]}
 */
function install () {
  if (install.installed) return
  install.installed = true
  Vue.mixin({
    beforeCreate () {
      const options = this.$options
      if (options.wechat) {
        this.$wechat = options.wechat
      } else if (options.parent && options.parent.$wechat) {
        this.$wechat = options.parent.$wechat
      }
    }
  })
}
Wechat.install = install
Wechat.version = '__VERSION__'
